
const REQUEST_STATUSES = {
  PENDING: ["created", "submitted"],
  RESOLVED: ["closed", "declined", "cancelled", "canceled", "accepted"],
};

export { REQUEST_STATUSES };
